"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _moment = _interopRequireDefault(require("moment"));

var _CwDialog = _interopRequireDefault(require("../../../cwdialog/CwDialog"));

var _CwButton = _interopRequireDefault(require("../../../cwbutton/CwButton"));

var _CwDatePicker = _interopRequireDefault(require("../../../cwdatepicker/CwDatePicker"));

var _CwLabel = _interopRequireDefault(require("../../../cwlabel/CwLabel"));

var _CwTimeField = _interopRequireDefault(require("../../../cwtimefield/CwTimeField"));

var _Dialogs = _interopRequireDefault(require("./Dialogs.scss"));

var DateFilterDialog =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(DateFilterDialog, _React$Component);
  (0, _createClass2.default)(DateFilterDialog, null, [{
    key: "formatDate",
    value: function formatDate(value) {
      var options = {
        weekday: 'short',
        month: 'numeric',
        year: 'numeric',
        day: 'numeric'
      };

      try {
        return new Intl.DateTimeFormat('en-US', options).format(value);
      } catch (e) {
        return 'Invalid Date';
      }
    }
  }, {
    key: "formatTime",
    value: function formatTime(time) {
      var tf = new Intl.DateTimeFormat('en-US', {
        hour: 'numeric',
        minute: 'numeric'
      });
      return tf.format((0, _moment.default)(time));
    }
  }, {
    key: "prepareFormattedDate",
    value: function prepareFormattedDate(value) {
      var returnValue = null;

      if (value) {
        returnValue = new Date(value);
      }

      return returnValue;
    }
  }, {
    key: "prepareTimeValue",
    value: function prepareTimeValue(value) {
      var returnValue = null;

      if (value) {
        if ((0, _typeof2.default)(value) === 'object') {
          returnValue = value;
        } else {
          var date = (0, _moment.default)(value);

          if (!date.isValid()) {
            returnValue = null;
          } else {
            returnValue = date;
          }
        }
      }

      return returnValue;
    }
  }]);

  function DateFilterDialog(props) {
    var _this;

    (0, _classCallCheck2.default)(this, DateFilterDialog);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(DateFilterDialog).call(this, props));
    _this.state = {
      startDate: null,
      startTime: null,
      endDate: null,
      endTime: null
    };
    _this.handleSaveClick = _this.handleSaveClick.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(DateFilterDialog, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // eslint-disable-next-line
      this.setState({
        startDate: this.props.initStartDate.length ? (0, _moment.default)(this.props.initStartDate) : null,
        startTime: this.props.initStartDate.length ? (0, _moment.default)(this.props.initStartDate) : null,
        endDate: this.props.initEndDate.length ? (0, _moment.default)(this.props.initEndDate) : null,
        endTime: this.props.initEndDate.length ? (0, _moment.default)(this.props.initEndDate) : null
      });
    }
  }, {
    key: "setDateRange",
    value: function setDateRange(value) {
      var momentDateStart = (0, _moment.default)({
        hour: 0,
        minute: 0,
        second: 0,
        millisecond: 0
      });
      var momentDateEnd = (0, _moment.default)({
        hour: 23,
        minute: 59,
        second: 59,
        millisecond: 999
      });

      switch (value) {
        case 'today':
          break;

        case '7 days':
          momentDateStart.subtract(7, 'days');
          break;

        case '30 days':
          momentDateStart.subtract(30, 'days');
          break;

        default:
          // clear button
          momentDateStart = null;
          momentDateEnd = null;
      }

      this.setState({
        startDate: momentDateStart,
        startTime: momentDateStart,
        endDate: momentDateEnd,
        endTime: momentDateEnd
      });
    }
  }, {
    key: "syncDateTimeValue",
    value: function syncDateTimeValue(stateKey, newValue) {
      switch (stateKey) {
        case 'startDate':
          if (!newValue) {
            this.setState({
              startTime: null
            });
          } else if (!this.state.startTime) {
            this.setState({
              startTime: (0, _moment.default)({
                h: 0,
                m: 0,
                s: 0
              })
            });
          }

          break;

        case 'startTime':
          if (!newValue) {
            this.setState({
              startDate: null
            });
          } else if (!this.state.startDate) {
            this.setState({
              startDate: (0, _moment.default)(this.state.startTime)
            });
          }

          break;

        case 'endDate':
          if (!newValue) {
            this.setState({
              endTime: null
            });
          } else if (!this.state.endTime) {
            this.setState({
              endTime: (0, _moment.default)({
                h: 23,
                m: 59,
                s: 59,
                ms: 999
              })
            });
          }

          break;

        case 'endTime':
          if (!newValue) {
            this.setState({
              endDate: null
            });
          } else if (!this.state.endDate) {
            this.setState({
              endDate: (0, _moment.default)(this.state.endTime)
            });
          }

          break;

        default: // do nothing

      }
    }
  }, {
    key: "handleDateTimeChange",
    value: function handleDateTimeChange(e, value, stateKey) {
      var _this2 = this;

      var newValue = null;

      if (value) {
        newValue = (0, _moment.default)("".concat(value.toISOString().split('.')[0], "Z"));
        this.setState((0, _defineProperty2.default)({}, stateKey, newValue), function () {
          _this2.syncDateTimeValue(stateKey, newValue);
        });
      } else if (e && e !== 'Invalid Date' && e !== '') {
        newValue = (0, _moment.default)(e);
        this.setState((0, _defineProperty2.default)({}, stateKey, newValue), function () {
          _this2.syncDateTimeValue(stateKey, newValue);
        });
      } else {
        this.setState((0, _defineProperty2.default)({}, stateKey, newValue), function () {
          _this2.syncDateTimeValue(stateKey, newValue);
        });
      }
    }
  }, {
    key: "handleSaveClick",
    value: function handleSaveClick() {
      var dateFormat = 'YYYY-MM-DD';
      var timeFormat = 'HH:mm:ssZ';
      var startDate = '';
      var startTime = '';
      var endDate = '';
      var endTime = '';

      if (_moment.default.isMoment(this.state.startDate)) {
        startDate = this.state.startDate.format(dateFormat);
      }

      if (_moment.default.isMoment(this.state.startTime)) {
        startTime = this.state.startTime.format(timeFormat);
      }

      if (_moment.default.isMoment(this.state.endDate)) {
        endDate = this.state.endDate.format(dateFormat);
      }

      if (_moment.default.isMoment(this.state.endTime)) {
        endTime = this.state.endTime.format(timeFormat);
      }

      var start = startDate.length && startTime.length ? "".concat(startDate, "T").concat(startTime) : '';
      var end = endDate.length && endTime.length ? "".concat(endDate, "T").concat(endTime) : '';
      this.props.onSaveClick(start, end);
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      return _react.default.createElement("div", {
        className: _Dialogs.default.dialogContainer
      }, _react.default.createElement("div", {
        className: _Dialogs.default.background
      }, _react.default.createElement(_CwDialog.default, {
        cwId: this.props.cwId,
        header: "Select a Date Range",
        buttons: [_react.default.createElement(_CwButton.default, {
          key: 0,
          cwId: "".concat(this.props.cwId, "_button_save"),
          value: "SAVE",
          onClick: this.handleSaveClick
        }), _react.default.createElement(_CwButton.default, {
          key: 2,
          cwId: "".concat(this.props.cwId, "_button_cancel"),
          value: "CANCEL",
          onClick: this.props.onCancelClick
        })]
      }, _react.default.createElement("div", {
        style: {
          marginBottom: 20
        }
      }, _react.default.createElement("div", {
        "data-cwid": "".concat(this.props.cwId, "_set_range_label"),
        className: _Dialogs.default.fieldLabel
      }, "Set Range"), _react.default.createElement(_CwButton.default, {
        cwId: "".concat(this.props.cwId, "_set_range_button_clear"),
        value: "Clear",
        onClick: function onClick() {
          _this3.setDateRange('clear');
        }
      }), _react.default.createElement(_CwButton.default, {
        cwId: "".concat(this.props.cwId, "_set_range_button_today"),
        value: "Today",
        onClick: function onClick() {
          _this3.setDateRange('today');
        }
      }), _react.default.createElement(_CwButton.default, {
        cwId: "".concat(this.props.cwId, "_set_range_button_last_7_days"),
        value: "Last 7 Days",
        onClick: function onClick() {
          _this3.setDateRange('7 days');
        }
      }), _react.default.createElement(_CwButton.default, {
        cwId: "".concat(this.props.cwId, "_set_range_button_last_30_days"),
        value: "Last 30 Days",
        onClick: function onClick() {
          _this3.setDateRange('30 days');
        }
      })), _react.default.createElement("div", {
        "data-cwid": "".concat(this.props.cwId, "_start_date_container"),
        className: _Dialogs.default.fieldContainer,
        style: {
          marginBottom: 20,
          paddingRight: 16
        }
      }, _react.default.createElement("div", {
        "data-cwid": "".concat(this.props.cwId, "_start_date_label"),
        className: _Dialogs.default.fieldLabel
      }, "Start Date"), _react.default.createElement(_CwDatePicker.default, {
        cwId: "".concat(this.props.cwId, "_start_date_picker"),
        formatter: DateFilterDialog.formatDate,
        localToday: "TODAY",
        triggerIcon: this.props.datePickerIcon,
        onChange: function onChange(e, value) {
          _this3.handleDateTimeChange(e, value, 'startDate');
        },
        value: DateFilterDialog.prepareFormattedDate(this.state.startDate),
        isDateTime: true,
        invalid: this.props.invalid
      })), _react.default.createElement("div", {
        "data-cwid": "".concat(this.props.cwId, "_start_time_container"),
        className: _Dialogs.default.fieldContainer,
        style: {
          marginBottom: 20,
          paddingLeft: 16
        }
      }, _react.default.createElement("div", {
        "data-cwid": "".concat(this.props.cwId, "_start_time_label"),
        className: _Dialogs.default.fieldLabel
      }, "Start Time"), _react.default.createElement(_CwTimeField.default, {
        cwId: "".concat(this.props.cwId, "_start_time_field"),
        formatTime: DateFilterDialog.formatTime,
        onChange: function onChange(e, value) {
          _this3.handleDateTimeChange(e, value, 'startTime');
        },
        value: DateFilterDialog.prepareTimeValue(this.state.startTime),
        invalid: this.props.invalid
      })), _react.default.createElement("div", {
        style: {
          clear: 'both'
        }
      }), _react.default.createElement("div", {
        "data-cwid": "".concat(this.props.cwId, "_end_date_container"),
        className: _Dialogs.default.fieldContainer,
        style: {
          paddingRight: 16
        }
      }, _react.default.createElement("div", {
        "data-cwid": "".concat(this.props.cwId, "_end_date_label"),
        className: _Dialogs.default.fieldLabel
      }, "End Date"), _react.default.createElement(_CwDatePicker.default, {
        cwId: "".concat(this.props.cwId, "_end_date_picker"),
        formatter: DateFilterDialog.formatDate,
        localToday: "TODAY",
        triggerIcon: this.props.datePickerIcon,
        onChange: function onChange(e, value) {
          _this3.handleDateTimeChange(e, value, 'endDate');
        },
        value: DateFilterDialog.prepareFormattedDate(this.state.endDate),
        isDateTime: true,
        invalid: this.props.invalid
      })), _react.default.createElement("div", {
        "data-cwid": "".concat(this.props.cwId, "_end_time_container"),
        className: _Dialogs.default.fieldContainer,
        style: {
          paddingLeft: 16
        }
      }, _react.default.createElement("div", {
        "data-cwid": "".concat(this.props.cwId, "_end_time_label"),
        className: _Dialogs.default.fieldLabel
      }, "End Time"), _react.default.createElement(_CwTimeField.default, {
        cwId: "".concat(this.props.cwId, "_end_time_field"),
        formatTime: DateFilterDialog.formatTime,
        onChange: function onChange(e, value) {
          _this3.handleDateTimeChange(e, value, 'endTime');
        },
        value: DateFilterDialog.prepareTimeValue(this.state.endTime),
        invalid: this.props.invalid
      })), _react.default.createElement("div", {
        style: {
          clear: 'both'
        }
      }), _react.default.createElement("div", {
        style: {
          marginTop: 8
        }
      }, _react.default.createElement(_CwLabel.default, {
        cwId: "".concat(this.props.cwId, "_error_text"),
        className: this.props.invalid ? _Dialogs.default.error : '',
        value: this.props.errorMessage
      })))));
    }
  }]);
  return DateFilterDialog;
}(_react.default.Component);

DateFilterDialog.propTypes = {
  cwId: _propTypes.default.string,
  datePickerIcon: _propTypes.default.string.isRequired,
  disabled: _propTypes.default.bool,
  errorMessage: _propTypes.default.string,
  initStartDate: _propTypes.default.string,
  initEndDate: _propTypes.default.string,
  invalid: _propTypes.default.bool,
  onSaveClick: _propTypes.default.func.isRequired,
  onCancelClick: _propTypes.default.func.isRequired
};
DateFilterDialog.defaultProps = {
  cwId: '',
  disabled: false,
  errorMessage: '',
  initStartDate: '',
  initEndDate: '',
  invalid: false
};
var _default = DateFilterDialog;
exports.default = _default;